<div>
  <label>{{ config.label }}</label>
  <div class="dynamic-form-field__item" *ngFor="let additionalService of additionalServicesAvailable">
    <cwc-checkbox (cwcChange)="additionalServiceChecked($event.detail, additionalService)" designVersion="v2">{{
      additionalService.additionalServiceLabel || additionalService.additionalServiceDesc | translate
    }}</cwc-checkbox>
  </div>
</div>
